import http from "../../app/utils/http";

export const PRODUCTS_URL = "products";


export const getProducts = (customer) => http.get(`${PRODUCTS_URL}?customerId=${customer.id}`)
